<template>
  <!-- 预约投保单 -->
  <div class="wrapper main-container">
    <div class="content">
      <div class="search-box gauge_20">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">状态</span>
          <Select v-model="searchParams.status" clearable>
            <Option v-for="(bean, i) in statusMap" :key="i" :value="i" v-if="i != '0'">{{ bean }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">姓名</span>
          <Input v-model="searchParams.holderName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">联系电话</span>
          <Input v-model="searchParams.holderMobile" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">预约来源</span>
          <Select v-model="searchParams.source" clearable>
            <Option v-for="(bean, i) in sourceMap" :key="i" :value="i">{{ bean }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">投保区域</span>
          <Input v-model="searchParams.insureArea" placeholder="请输入" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="warning" @click="$refs.addForm.open()">新增</Button>
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row, index }" slot="action">
            <div class="detail">
              <!-- 申请失败 -->
              <span class="btn disabled" v-if="row.status == 3 || row.status == 0">-</span>
              <!-- 已申请 -->
              <span class="btn disabled" v-if="row.status == 1">申请已发送</span>
              <!-- 申请成功 -->
              <span class="btn" v-if="row.status == 2" @click="$units.copyUrl(row.insureUrl)">复制投保链接</span>
              <Poptip trigger="hover" v-if="row.status == 2" placement="bottom-end">
                <div slot="content">
                  <div :id="'code' + row.id">
                    <vueQr :text="row.insureUrl" :size="180" :margin="10" />
                    <div class="btn" @click="downloadCode('code' + row.id, row)">下载二维码</div>
                  </div>
                </div>
                <span class="btn">二维码</span>
              </Poptip>
              <!-- 已过期 -->
              <Tooltip
                placement="bottom"
                v-if="[4, 6, 7, 8, 9].includes(row.status * 1)"
                trigger="hover"
                :content="row.status == 4 ? '投保链接已过有效期' : '投保链接已使用'"
              >
                <div>
                  <span class="btn disabled">复制投保链接</span>
                  <span class="btn disabled" style="margin-left: 20px">二维码</span>
                </div>
              </Tooltip>
              <!-- 投保成功、出单成功 -->
              <span
                class="btn"
                v-if="row.status == 5"
                @click="
                  $refs.detailModal.open({
                    policyNo: row.policyNo,
                    orgName: row.mechanName,
                    groupName: row.groupName,
                    salesmanName: row.salesManName
                  })
                "
                >详情</span
              >
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
        </div>
      </div>
    </div>
    <!-- 保单详情弹窗  -->
    <detailModal ref="detailModal"></detailModal>
    <!-- 修改基本信息  -->
    <addForm ref="addForm" @suceess="searchAjax()"></addForm>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
import addForm from "./components/addForm";
import detailModal from "@/pages/orderManage/insuredOrder/components/detailModal";
import vueQr from "vue-qr";

export default {
  components: {
    detailModal,
    addForm,
    vueQr,
  },
  mixins: [pageTool],
  props: {},
  data() {
    return {
      sourceMap: {
        "1": "H5",
        "3": "PC",
        "4": "平台",
        "5": "微信",
        "6": "支付宝",
        "7": "APP",
        "8": "PC扫码",
      },
      statusMap: {
        "0": "未申请",
        "1": "申请中",
        "2": "申请成功",
        "3": "申请失败",
        "4": "已过期",
        "5": "投保成功",
        "6": "延期",
        "7": "拒保",
        "8": "问题件",
        "9": "已撤单",
      },
      columns: [
        {
          title: "姓名/联系电话",
          key: "holderName",
          align: "center",
          maxWidth: 210,
          minWidth: 140,
          render(h, params) {
            if (params.row.holderName && params.row.holderMobile2) {
              return <span>{(params.row.holderName || '-') + '/' + (params.row.holderMobile2 || '-')}</span>;
            } else if (params.row.holderName) {
              return <span>{params.row.holderName}</span>;
            } else if (params.row.holderMobile2) {
              return <span>{params.row.holderMobile2}</span>;
            }
          },
        },
        {
          title: "投保产品",
          key: "productName",
          align: "center",
          minWidth: 230,
        },
        {
          title: "投保区域",
          key: "insureArea",
          width: "100",
          align: "center",
        },
        {
          title: "预约来源",
          key: "source",
          width: "80",
          align: "center",
          render: (h, params) => {
            return <span>{this.sourceMap[params.row.source]}</span>;
          },
        },
        {
          title: "身份证号",
          key: "holderIdCard",
          width: "140",
          align: "center",
        },
        {
          title: "状态",
          key: "status",
          width: "80",
          align: "center",
          render: (h, params) => {
            return <span>{this.statusMap[params.row.status]}</span>;
          },
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          minWidth: 150,
          render(h, params) {
            let text = params.row.remark;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: "所属团队",
          align: "center",
          key: "groupNameFull",
          minWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          width: "140",
          align: "center",
          render(h, params) {
            const date = params.row.createTime.substring(0, 16);
            return <span>{date}</span>;
          },
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "180",
        },
      ],
      tableDate: [],
      tableDate_deal: [],
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.initListAjax("/buz/appointInsured/read/list");
  },
  methods: {
    // 下载二维码
    downloadCode(id, item) {
      var url = document.getElementById(id).children[0].src;
      this.$units.dataToBlob(item.holderName, url);

    },
    // 转化参数
    setListParams(params) {

    },
    listCallback(resData) {
      resData.data.forEach(item => {
        if (item.groupName) {
          item.groupNameFull = item.mechanName + "/" + item.groupName
        } else {
          item.groupNameFull = item.mechanName
        }
      })
    },
    // 删除
    del(row) {
      this.$notice.inquiry("确定删除合同？").then(() => {
        this.$http({
          url: "/buz/userContract/del",
          type: "get",
          data: {
            id: row.id,
          }
        }).then(res => {
          this.$notice.success("删除合同成功");
          this.searchAjax();
        })
      });
    },
    // 导出合同
    async daochu(row) {
      try {
        this.listLoading = true;
        const res = await this.$http({
          type: "GET",
          forced: true,
          responseType: "blob",
          All: true,
          url: "/buz/userContract/downloadZip",
          data: { id: row.id }
        });
        this.$units.daochu(res);
      } catch (error) {
        this.$notice && this.$notice.error("导出合同失败");
      } finally {
        this.listLoading = false;
      }
    },
  },

};
</script>
<style lang="scss" scoped>
.wrapper .content {
  padding-bottom: 0;
  overflow: hidden;
  .table-box {
    .detail {
      .btn {
        color: #236dff;
        font-size: 13px;
        cursor: pointer;
      }
      .disabled {
        color: #666;
        cursor: default;
      }
    }
  }
}
</style>
